import { Table } from "../../../../components/table-components/Table";
import { UserOrderHeader } from "./UserOrderHeader";
import { UserOrder } from "../../../shop/model/OrderSuccessResponse";
import { UserOrderRow } from "./UserOrderRow";
import { SpinnerBlock } from "../../../common/Spinner";
import { Placeholder } from "../../../../components/Placeholder";

type Props = {
  orders: UserOrder[] | undefined;
  isLoading: boolean;
};

export const UserOrdersList = ({ orders, isLoading }: Props) => {
  if (isLoading) {
    return <SpinnerBlock />;
  }

  if (orders?.length === 0) {
    return <Placeholder>User has no orders.</Placeholder>;
  }

  return (
    <Table>
      <UserOrderHeader />
      <tbody>
        {orders?.map((order, index) => (
          <UserOrderRow key={index} order={order} />
        ))}
      </tbody>
    </Table>
  );
};
